import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/database";
import "firebase/compat/analytics";
import "firebase/compat/app-check";
import "firebase/compat/storage";
import "firebase/compat/auth";
import { environment, env } from "./configs/environment";

firebase.initializeApp(environment.config);
const appCheck = firebase.appCheck();

if (env === "local" || env === "environment") {
  self["FIREBASE_APPCHECK_DEBUG_TOKEN"] = true;
  console.log("Firebase App Check debug token enabled");
}

appCheck.activate(
  new firebase.appCheck.ReCaptchaEnterpriseProvider(environment.recaptchaKey),
);
// Initialize analytics only if supported (not in local dev or if measurementId is configured)
if (environment.config.measurementId && typeof window !== "undefined") {
  try {
    firebase.analytics();
  } catch (error) {
    console.warn("Firebase Analytics not available:", error);
  }
}

const db = firebase.firestore();

export { db, firebase };
